import React from 'react';

import src from '../../images/background.png';
import './style.css';

const BackgroundImage = () => {
  return <img id="background" src={src} alt="dark background" />;
};

export default BackgroundImage;
